import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { edit_patient, upload_patient } from "../../actions/clinic_content";
import { checkAuthenticated } from "../../actions/auth";
import { useDispatch } from "react-redux";
import { load_users_short } from "../../actions/user_content";

const initialPatientData = {
  email: "",
  rut: "",
  name: "",
  first_lastname: "",
  second_lastname: "",
  age: "",
  birthday: null,

  sex: "",
  address: "",
  phone: "",
  country: "",
  prevision: "",

  occupation: "",
  health_info: {
    assigned_professional: null,
    anamnesis: "",
    evaluation: "",
    objectives: "",

    diagnosis: "",
    medical_quote_date: null,
    doctors_name: "",
  },
};
const CreatePatientModal = (props) => {
  const dispatch = useDispatch();
  const { show, onHide, patientId, loadedPatientData } = props;
  const nowDate = new Date();
  // Patient states
  const [patientData, setPatientData] = useState(initialPatientData);
  const [patientFiles, setPatientFiles] = useState([]);
  // Modal states
  const [usersOptions, setUsersOptions] = useState([]);
  const [apiError, setApiError] = useState(null);
  const [apiDetailError, setApiDetailError] = useState({});
  const [showErrorDetail, setShowErrorDetail] = useState(false);
  const [copiedDetail, setCopiedDetail] = useState(false);
  const [formAlerts, setFormAlerts] = useState({
    name: false,
    rut: false,
    first_lastname: false,
  });

  const checkEmptyFields = (keyList) => {
    let isEmpty = false;
    const newFormData = { ...patientData };
    keyList.forEach((key) => {
      if (patientData[key].toString().trim() === "") {
        formAlerts[key] = true;
        isEmpty = true;
      } else {
        formAlerts[key] = false;
      }

      setTimeout(() => {
        setFormAlerts({ name: false, rut: false, first_lastname: false });
      }, 3500);
    });

    setPatientData(newFormData);
    return isEmpty;
  };
  // fetch functions
  const fetchOptions = async () => {
    // dispatch(checkAuthenticated());

    const professionals = await load_users_short();
    setUsersOptions(professionals);
  };

  // Handle functions
  const handleChange = (e, path, convertEmptyToNull = false) => {
    const value = e.target.value === "" && convertEmptyToNull 
      ? null 
      : e.target.value;

    setPatientData((prevPatientData) => {
      let keys = path.split(".");
      let currentLevel = prevPatientData;
      for (let i = 0; i < keys.length - 1; i++) {
        currentLevel = currentLevel[keys[i]];
      }
      currentLevel[keys[keys.length - 1]] = value;
      return { ...prevPatientData };
    });
  };

  const handleUpload = async () => {
    dispatch(checkAuthenticated());
    setApiError(null);
    if (!checkEmptyFields(["name", "rut", "first_lastname"])) {
      try {
        await upload_patient(patientData, patientFiles);
        setPatientData(initialPatientData);
        setPatientFiles([]);
        onHide();
      } catch (err) {
        if (err.isAuthError) {
          setApiDetailError(err.message);
          setApiError(err.message);
        } else {
          setApiDetailError({
            status: err.status,
            error_response: err.response?.data,
          });
          setApiError(
            "Ocurrió un error inesperado. Por favor, intente nuevamente.",
          );
        }
      }
    }
  };
  const handleUploadEdit = async () => {
    dispatch(checkAuthenticated());
    setApiError(null);
    try {
      await edit_patient(patientId, patientData);
      onHide();
    } catch (err) {
      if (err.isAuthError) {
        setApiDetailError({
          status: err.status,
          message: err.message,
        });
        setApiError(err.message);
      } else {
        setApiDetailError({
          status: err.status,
          error_response: err.response?.data,
        });
        setApiError(
          "Ocurrió un error inesperado. Por favor, intente nuevamente.",
        );
      }
    }
  };
  const submitButtons = {
    create: () => (
      <Button variant="primary" onClick={handleUpload}>
        Registrar
      </Button>
    ),
    edit: () => (
      <Button variant="primary" onClick={handleUploadEdit}>
        Guardar Cambios
      </Button>
    ),
  };

  useEffect(() => {
    fetchOptions();
    if (loadedPatientData) {
      const { created, ...filteredData } = loadedPatientData;
      setPatientData(filteredData);
    }
  }, []);
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header className="justify-content-center">
        <Modal.Title
          id="contained-modal-title-vcenter"
          className="justify-content-center"
        >
          Nuevo Paciente / Ficha
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {apiError && (
          <div
            className="alert alert-danger alert-dismissible fade show"
            role="alert"
          >
            <div className="d-flex align-items-center justify-content-between">
              <span>{apiError}</span>
              <div className="d-flex align-items-center gap-2 ms-2">
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() => {
                    setShowErrorDetail((prev) => !prev);
                    setCopiedDetail(false);
                  }}
                >
                  {showErrorDetail ? "Ocultar detalles" : "Ver detalles"}
                </Button>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setApiError(null);
                    setShowErrorDetail(false);
                    setCopiedDetail(false);
                  }}
                  aria-label="Close"
                ></button>
              </div>
            </div>
            {showErrorDetail && apiDetailError && (
              <div className="mt-2">
                <div className="d-flex justify-content-end mb-1">
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={() => {
                      const detail =
                        apiDetailError instanceof Error
                          ? `${apiDetailError.message}\n${apiDetailError.stack || ""}`
                          : typeof apiDetailError === "object"
                            ? JSON.stringify(apiDetailError, null, 2)
                            : String(apiDetailError);
                      navigator.clipboard.writeText(detail).then(() => {
                        setCopiedDetail(true);
                        setTimeout(() => setCopiedDetail(false), 2000);
                      });
                    }}
                  >
                    {copiedDetail ? "✓ Copiado" : "Copiar"}
                  </Button>
                </div>
                <pre
                  className="bg-dark text-light p-2 rounded mb-0"
                  style={{
                    maxHeight: "200px",
                    overflowY: "auto",
                    fontSize: "0.8rem",
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                  }}
                >
                  {apiDetailError instanceof Error
                    ? `${apiDetailError.message}\n${apiDetailError.stack || ""}`
                    : typeof apiDetailError === "object"
                      ? JSON.stringify(apiDetailError, null, 2)
                      : String(apiDetailError)}
                </pre>
              </div>
            )}
          </div>
        )}
        <div className="d-flex justify-content-between align-items-center">
          <strong>
            Fecha: {nowDate.getFullYear()}-{nowDate.getMonth() + 1}-
            {nowDate.getDate()}
          </strong>
          {patientId && <strong>Numero Ficha: {patientId}</strong>}
        </div>
        <div className="row justify-content-between">
          <div className="col">
            <h4>Datos Personales</h4>
            <div className="d-flex flex-wrap gap-2">
              <div className="input-field flex-fill">
                <label htmlFor="nameFormControlInput" className="form-label">
                  Nombre
                  <strong className="text-danger">*</strong>
                  <span
                    className={
                      formAlerts.name ? "fst-italic m-2 text-danger" : "d-none"
                    }
                  >
                    No valido.
                  </span>
                </label>
                <input
                  type="text"
                  className={
                    formAlerts.name
                      ? "border border-danger form-control"
                      : "form-control"
                  }
                  id="nameFormControlInput"
                  onChange={(e) => handleChange(e, "name")}
                  value={patientData.name}
                />
              </div>
              <div className="input-field flex-fill">
                <label htmlFor="rutFormControlInput" className="form-label">
                  Rut
                  <strong className="text-danger">*</strong>
                  <span
                    className={
                      formAlerts.rut ? "fst-italic m-2 text-danger" : "d-none"
                    }
                  >
                    No valido.
                  </span>
                </label>
                <input
                  type="text"
                  className={
                    formAlerts.rut
                      ? "border border-danger form-control"
                      : "form-control"
                  }
                  id="rutFormControlInput"
                  onChange={(e) => handleChange(e, "rut")}
                  value={patientData.rut}
                />
              </div>

              <div className="input-field flex-fill">
                <label
                  htmlFor="first_lastnameFormControlInput"
                  className="form-label"
                >
                  Primer Apellido
                  <strong className="text-danger">*</strong>
                  <span
                    className={
                      formAlerts.first_lastname
                        ? "fst-italic m-2 text-danger"
                        : "d-none"
                    }
                  >
                    No valido.
                  </span>
                </label>
                <input
                  type="text"
                  className={
                    formAlerts.first_lastname
                      ? "border border-danger form-control"
                      : "form-control"
                  }
                  id="first_lastnameFormControlInput"
                  onChange={(e) => handleChange(e, "first_lastname")}
                  value={patientData.first_lastname}
                />
              </div>
              <div className="input-field flex-fill">
                <label
                  htmlFor="second_lastnameFormControlInput"
                  className="form-label"
                >
                  Segundo Apellido
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="second_lastnameFormControlInput"
                  onChange={(e) => handleChange(e, "second_lastname")}
                  value={patientData.second_lastname}
                />
              </div>

              <div className="input-field flex-fill">
                <label htmlFor="ageFormControlInput" className="form-label">
                  Edad
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="ageFormControlInput"
                  onChange={(e) => handleChange(e, "age")}
                  value={patientData.age}
                />
              </div>
              <div className="input-field flex-fill">
                <label htmlFor="countryFormControlInput" className="form-label">
                  Nacionalidad
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="countryFormControlInput"
                  onChange={(e) => handleChange(e, "country")}
                  value={patientData.country}
                />
              </div>

              <div className="input-field flex-fill">
                <label
                  htmlFor="birthdayFormControlInput"
                  className="form-label"
                >
                  Nacimiento
                </label>
                <input
                  type="date"
                  className="form-control"
                  id="birthdayFormControlInput"
                  onChange={(e) => handleChange(e, "birthday", true)}
                  value={patientData.birthday}
                />
              </div>
              <div className="input-field flex-fill">
                <label htmlFor="phoneFormControlInput" className="form-label">
                  Telefono
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="phoneFormControlInput"
                  onChange={(e) => handleChange(e, "phone")}
                  value={patientData.phone}
                />
              </div>

              <div className="input-field flex-fill">
                <label htmlFor="sexFormControlInput" className="form-label">
                  Sexo
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="sexFormControlInput"
                  onChange={(e) => handleChange(e, "sex")}
                  value={patientData.sex}
                />
              </div>
              <div className="input-field flex-fill">
                <label htmlFor="emailFormControlInput" className="form-label">
                  Email address
                </label>
                <input
                  type="email"
                  className="form-control"
                  id="emailFormControlInput"
                  onChange={(e) => handleChange(e, "email")}
                  value={patientData.email}
                />
              </div>

              <div className="input-field flex-fill">
                <label
                  htmlFor="previsionFormControlInput"
                  className="form-label"
                >
                  Prevision
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="previsionFormControlInput"
                  onChange={(e) => handleChange(e, "prevision")}
                  value={patientData.prevision}
                />
              </div>
              <div className="input-field flex-fill">
                <label
                  htmlFor="occupationFormControlInput"
                  className="form-label"
                >
                  Ocupacion
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="occupationFormControlInput"
                  onChange={(e) => handleChange(e, "occupation")}
                  value={patientData.occupation}
                />
              </div>

              <div className="input-field flex-fill">
                <label htmlFor="addressFormControlInput" className="form-label">
                  Direccion
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="addressFormControlInput"
                  onChange={(e) => handleChange(e, "address")}
                  value={patientData.address}
                />
              </div>
            </div>
          </div>
          <div className="col-auto d-none d-lg-flex p-0">
            <div className="vr"></div>
          </div>
          <div className="col">
            <h4>Datos Kinesicos</h4>
            <div className="d-flex flex-column gap-2">
              <div className="input-field flex-fill">
                <label className="form-label">Kinesiologo</label>
                <select
                  className="form-select"
                  aria-label="Default select example"
                  onChange={(e) =>
                    handleChange(e, "health_info.assigned_professional", true)
                  }
                  value={patientData.health_info.assigned_professional}
                >
                  <option value="">N/A</option>
                  {usersOptions?.map((professional) => (
                    <option value={professional.id} key={professional.id}>
                      {professional.name} {professional.first_lastname}{" "}
                      {professional.second_lastname} - {professional.occupation}
                    </option>
                  ))}
                </select>
              </div>

              <div className="input-field">
                <label
                  htmlFor="anamnesisFormControlTextarea1"
                  className="form-label"
                >
                  Anamnesis
                </label>
                <textarea
                  className="form-control"
                  id="anamnesisFormControlTextarea1"
                  rows="3"
                  onChange={(e) => handleChange(e, "health_info.anamnesis")}
                  value={patientData.health_info.anamnesis}
                />
              </div>
              <div className="input-field">
                <label
                  htmlFor="evaluationFormControlTextarea1"
                  className="form-label"
                >
                  Evaluacion Kinesica
                </label>
                <textarea
                  className="form-control"
                  id="evaluationFormControlTextarea1"
                  rows="3"
                  onChange={(e) => handleChange(e, "health_info.evaluation")}
                  value={patientData.health_info.evaluation}
                />
              </div>
              <div className="input-field">
                <label
                  htmlFor="objectivesFormControlTextarea1"
                  className="form-label"
                >
                  Objetivos de tratamiento
                </label>
                <textarea
                  className="form-control"
                  id="objectivesFormControlTextarea1"
                  rows="3"
                  onChange={(e) => handleChange(e, "health_info.objectives")}
                  value={patientData.health_info.objectives}
                />
              </div>

              <div className="row">
                <div className="input-field col">
                  <label
                    htmlFor="medicQuoteDateFormControlInput"
                    className="form-label"
                  >
                    Fecha Atencion Medica
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id="medicQuoteDateFormControlInput"
                    onChange={(e) =>
                      handleChange(e, "health_info.medical_quote_date", true)
                    }
                    value={patientData.health_info.medical_quote_date}
                  />
                </div>
                <div className="input-field col">
                  <label
                    htmlFor="medicNameFormControlInput"
                    className="form-label"
                  >
                    Nombre Medico
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="medicNameFormControlInput"
                    onChange={(e) =>
                      handleChange(e, "health_info.doctors_name")
                    }
                    value={patientData.health_info.doctors_name}
                  />
                </div>
              </div>

              <div className="input-field">
                <label
                  htmlFor="diagnosisFormControlTextarea1"
                  className="form-label"
                >
                  Diagnostico
                </label>
                <textarea
                  className="form-control"
                  id="diagnosisFormControlTextarea1"
                  rows="3"
                  onChange={(e) => handleChange(e, "health_info.diagnosis")}
                  value={patientData.health_info.diagnosis}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button variant="secondary" onClick={onHide}>
          Cancelar
        </Button>
        {patientId ? submitButtons.edit() : submitButtons.create()}
      </Modal.Footer>
    </Modal>
  );
};

export default CreatePatientModal;
